import React, { ChangeEvent, FunctionComponent, useEffect, useState } from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import { concat } from '../../common/helpers/arrayHelper';
import { IBindingCallback1 } from '../../common/models/callback';
import styles from './styles.module.scss';

interface IProps {
  size?: 'md' | 'lg';
  label?: string;
  placeholder?: string;
  onChange: IBindingCallback1<string>;
  input?: string;
}

const TextArea: FunctionComponent<IProps> = ({ size = 'md', label, placeholder, onChange, input }) => {
  const val = input || '';

  const [value, setValue] = useState(val);

  useEffect(() => {
    if (value !== val) {
      setValue(val);
    }
  }, [val]);

  const change = (e: ChangeEvent<HTMLTextAreaElement>) => {
    const { value: v } = e.currentTarget;
    setValue(v);
    onChange(v);
  };

  return (
    <div>
      {
        label ? (
          <span className={`t-16 ${styles.label}`}>
            {label}
          </span>
        ) : null
      }
      <TextareaAutosize
        value={value}
        onChange={change}
        placeholder={placeholder || ''}
        className={concat(
          styles.textarea,
          styles[size],
          'textarea',
          label ? 'mt-2' : ''
        )}
        minRows={5}
        maxRows={20}
      />
    </div>
  );
};

export default TextArea;
